import * as React from 'react';
import { FileProps } from '../type';
import { File } from './File';

export const FileSuccess: React.SFC<FileProps> = (props) => (
  <File className="elmo-uploaded-file__accepted" {...props} />
);
